import moment from "moment";

const datesBetween = (startDate, endDate) => {
    let now = moment(startDate, 'YYYY-MM-DD').clone(), dates = [];
    while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('DD-MM-YYYY'));
        now.add(1, 'days');
    }
    return dates;
};

const daysBetween = (startDate, endDate) => {
    let now = moment(startDate, 'YYYY-MM-DD').clone(), dates = [];
    while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('dddd'));
        now.add(1, 'days');
    }
    return dates;
};

export { datesBetween, daysBetween };